// reCaptcha keys for login and signup human validation
const reCaptcha_keys = {
  public_key: "6Ld_tIwaAAAAAJwEF-G6DcuxlTxc9kl0llJGlumM",
 
};

export default reCaptcha_keys;
